import {
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";

const AddReceiptsMethodSelection = () => {
  return (
    <>
      <Typography mb={2} variant="body1">
        You can add receipts in two ways: either upload a file directly or enter
        the details manually. <br />
        Choose the method that best fits your workflow.
      </Typography>
      <Typography variant="body1" fontWeight={500}>
        Receipt Creation Options
      </Typography>

      <FormControl sx={{ mt: 1 }}>
        <RadioGroup row>
          <FormControlLabel
            value="uploadFile"
            control={<Radio size="small" color="secondary" />}
            label="Upload a file"
          />
          <FormControlLabel
            value="manual_input"
            control={<Radio size="small" color="secondary" />}
            label="Manual input"
          />
        </RadioGroup>
      </FormControl>
    </>
  );
};

export default AddReceiptsMethodSelection;
